import { render, staticRenderFns } from "./IcoGameController.vue?vue&type=template&id=808ae70c"
import script from "./IcoGameController.vue?vue&type=script&lang=js"
export * from "./IcoGameController.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports